import React, { useEffect, useRef, useState, useCallback } from 'react';
import { SafeAreaView, Animated } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { ViewPropTypes, ImagePropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme, Types, LightThemeColors, Metrics } from '../Themes';

import Header from './Header';

const AnimatedLinearGradient = Animated.createAnimatedComponent(LinearGradient);

const VFBackground = ({
  type,
  children,
  showHeader,
  onClose,
  isAnimated,
  style,
  source: sourceProp,
  ...props
}) => {
  const theme = useTheme() || LightThemeColors;
  const { colors } = theme;
  const backgroundSource = sourceProp || colors.background[type];
  const [source, setSource] = useState(backgroundSource);
  const prevType = usePrevious(type, Types.PRIMARY);
  const didChange = useRef();
  const [imageAnim] = useState(new Animated.Value(1));

  const logoChangeAnim = useCallback(
    fade =>
      Animated.timing(imageAnim, {
        toValue: fade ? 0 : 1,
        duration: 100,
        useNativeDriver: false
      }),
    [imageAnim]
  )

  useEffect(() => {
    if (prevType !== type && isAnimated) {
      clearTimeout(didChange.current);
      logoChangeAnim(true).start();
      didChange.current = setTimeout(() => {
        setSource(backgroundSource);
        logoChangeAnim(false).start();
      }, 200);
    } else {
      setSource(backgroundSource);
    }
  }, [isAnimated, logoChangeAnim, prevType, type, theme]);



  const opacity = imageAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [0.7, 1],
  });

  return (
    <AnimatedLinearGradient
      colors={isAnimated ? source : sourceProp || colors.background[type]}
      {...Metrics.backgroundGradientOrientation}
      style={[style, { opacity }]}
      {...props}
    >
      {showHeader && (
        <SafeAreaView>
          <Header type={type} onClose={onClose} />
        </SafeAreaView>
      )}
      {children}
    </AnimatedLinearGradient>
  );
};

function usePrevious(value, defaultValue = null) {
  const ref = useRef(defaultValue);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

VFBackground.defaultProps = {
  type: Types.PRIMARY,
  showHeader: false,
  onClose: () => { },
  style: { flex: 1 },
  isAnimated: false,
};

VFBackground.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY, Types.TERTIARY]),
  showHeader: PropTypes.bool,
  onClose: PropTypes.func,
  style: ViewPropTypes.style,
  isAnimated: PropTypes.bool,
  source: ImagePropTypes.source,
};

export default VFBackground;
